export const APPLICATION_TVA_TYPE_NORMAL = 'Normal';
export const APPLICATION_TVA_TYPE_EXPORT_HORS_UE = 'ExportHorsUE';
export const APPLICATION_TVA_TYPE_INTRACOMMUNAUTAIRE = 'Intracommunautaire';
export const APPLICATION_TVA_TYPE_NON_APPLICABLE = 'NonApplicable';

export const LISTE_APPLICATION_TVA = [
  { code: APPLICATION_TVA_TYPE_NORMAL, libelle: 'Normal' },
  { code: APPLICATION_TVA_TYPE_EXPORT_HORS_UE, libelle: 'Export hors UE' },
  { code: APPLICATION_TVA_TYPE_INTRACOMMUNAUTAIRE, libelle: 'Intracommunautaire' },
  { code: APPLICATION_TVA_TYPE_NON_APPLICABLE, libelle: 'Non applicable' },
];



// WEBPACK FOOTER //
// ./src/configuration/applicationTvaConf.js